import type { FC } from 'react';

import { SkeletonLoading } from '@zen/DesignSystem';

import { wizardSteps } from '../../constants';
import type { WizardStepConfig } from '../../types';
import WizardFooter from '../WizardFooter';
import WizardLayout from '../WizardLayout';
import WizardMasthead from '../WizardMasthead';
import WizardStepHeader from '../WizardStepHeader';
import WizardStepper from '../WizardStepper';

const firstStep: WizardStepConfig = wizardSteps[0];

const ignoreInteraction = (): void => {};

const BookingWizardSkeleton: FC = () => {
  return (
    <WizardLayout
      footer={
        <WizardFooter
          isDisabled={true}
          isFirstStep={true}
          isLastStep={false}
          isSubmitting={false}
          onBack={ignoreInteraction}
          onNext={ignoreInteraction}
        />
      }
      masthead={
        <WizardMasthead isDisabled={true} isSavingDraft={false} onDiscard={ignoreInteraction} onSaveDraft={ignoreInteraction} />
      }
      stepId={firstStep.id}
      stepper={<WizardStepper currentStepIndex={0} onStepClick={ignoreInteraction} steps={wizardSteps} visitedSteps={[]} />}
    >
      <WizardStepHeader subtitle={firstStep.subtitle} title={firstStep.title} />
      <div className="space-y-6" data-component="booking-wizard-skeleton">
        <SkeletonLoading className="mx-0!" height={160} />
        <SkeletonLoading className="mx-0!" height={240} />
        <SkeletonLoading className="mx-0!" height={160} />
      </div>
    </WizardLayout>
  );
};

export default BookingWizardSkeleton;
